<div *ngIf="!(data?.length > 0) && loading" class="table-layout">
  <lib-loading-indicator></lib-loading-indicator>
</div>
